/* eslint-disable import/no-cycle */
import { all, fork } from 'redux-saga/effects';
import chatsSagas from './chats.sagas';
import invitesSagas from './invites.sagas';

export default function* networkingSagas() {
  yield all([chatsSagas, invitesSagas].map(fork));
}
